<div class="project-card" (click)="getSharedProject()">
  <!-- Imagem inset (como em prod), chanfrada -->
  <div class="project-media">
    <div class="project-frame">
      <div class="project-image" [ngStyle]="{'background-image': imageStyle}"></div>
    </div>
    <span class="heart-badge" [ngClass]="{ 'favorite': project?.isFavorite }" (click)="$event.stopPropagation(); toggleFavoriteProject()">
      <i class="pi" [ngClass]="project?.isFavorite ? 'pi-heart-fill' : 'pi-heart'"></i>
    </span>
  </div>

  <div class="project-info">
    <h3 class="project-title">{{ project?.projectName }}</h3>

    <!-- Linha: dono à esquerda, aplicação (badge de marca) à direita — layout de prod -->
    <div class="project-subrow">
      <ng-container *ngIf="project?.ownerUserName as userName">
        <span class="project-user">{{ userName.split(' ')[0] }}</span>
      </ng-container>
      <span class="chip chip--accent" *ngFor="let applications of project?.application">{{ applications.name }}</span>
    </div>

    <div class="project-tags">
      <span class="chip" *ngIf="project?.attributes?.manufacturer">{{ project?.attributes?.manufacturer }}</span>
      <span class="chip" *ngIf="project?.attributes?.['date-of-manufacture']">{{ project?.attributes?.['date-of-manufacture'] | date: 'yyyy' }}</span>
    </div>

    <div class="project-footer">
      <span class="likes-count tnum">
        <i class="pi pi-heart-fill"></i>
        {{ project?.likes || 0 }}
      </span>
      <span class="go-btn" aria-hidden="true">
        <i class="pi pi-chevron-right"></i>
      </span>
    </div>
  </div>
</div>
